import React, { useState } from "react";
import logo1 from "../../assets/tags.webp";

const cardData = [
  {
    title: "Verified Profiling",
    description: [
      "Builds user trust and confidence.",
      "Reduces the risk of misinformation or scams.",
      "Improves the credibility of listed businesses."
    ]
  },
  {
    title: "Unique KahaTAG",
    description: [
      "Easier to Memorise and Makes finding locations sharing faster and easier.",
      "Enables businesses and individuals to establish a clear digital presence.",
      "Improves accessibility for users in urban and rural areas."
    ]
  },
  {
    title: "In-App Navigation",
    description: [
      "Saves time by eliminating the need for external navigation apps.",
      "Ensures accurate routes to destinations.",
      "Supports offline navigation for convenience."
    ]
  },
  {
    title: "360° Photos & Videos",
    description: [
      "Offers an immersive experience for users before visiting.",
      "Enhances business visibility and user engagement.",
      "Increases trust through transparency."
    ]
  },
  {
    title: "In-App Chat & Call",
    description: [
      "Simplifies communication without the need for external apps.",
      "Boosts customer interaction for businesses.",
      "Increases convenience for users to resolve queries instantly."
    ]
  },
  {
    title: "Digital Ad Space & Notice Board",
    description: [
      "Provides cost-effective marketing opportunities.",
      "Increases visibility for business promotions.",
      "Keeps users informed about offers, events, and announcements."
    ]
  },
  {
    title: "Push Notifications",
    description: [
      "Ensures timely communication with users.",
      "Improves app engagement by delivering relevant information.",
      "Helps businesses reach their audience directly."
    ]
  },
  {
    title: "Digital Marketplace",
    description: [
      "Creates an additional revenue stream for businesses.",
      "Offers users a convenient shopping experience.",
      "Facilitates easy discovery of local businesses and products."
    ]
  },
  {
    title: "Reviews & Ratings",
    description: [
      "Encourages businesses to maintain quality service.",
      "Helps users make informed decisions.",
      "Builds transparency and trust within the platform."
    ]
  }
];

const TagSolu = () => {
  const [activeCard, setActiveCard] = useState(0);

  const handleCardClick = (index) => {
    setActiveCard(index);
  };

  return (
    <div className="flex flex-col justify-center items-center bg-[#F5F9FE] py-20 md:py-28">
      <section className="w-full xl:w-2xl">
        <div className="font-bold text-3xl sm:text-4xl text-center">
          Kaha! One Tag Solution
        </div>
        <div className="flex flex-col items-center mt-11 mb-6 md:mb-16">
          {/* Card Section */}
          <div className="flex flex-wrap gap-4 sm:gap-6 justify-center w-full px-8">
            {cardData.map((card, index) => (
              <div
                key={index}
                className={`text-base px-10 py-2 rounded-xl font-medium border-2 border-slate-700 hover:bg-[#2F80ED]/70 hover:text-white ${
                  activeCard === index && "bg-[#2F80ED] text-white"
                } cursor-pointer`}
                onClick={() => handleCardClick(index)}
              >
                {card.title}
              </div>
            ))}
          </div>
        </div>

        {/* Details Section */}
        {cardData[activeCard] && (
          <div
            className="flex flex-col justify-center items-center px-4 sm:px-6 xl:px-0"
            data-aos="fade-right"
            data-aos-offset="300"
            data-aos-easing="ease-in-sine"
          >
            <div className="flex flex-col md:flex-row xl:w-[80%] w-full">
              <div className="hidden md:block md:w-1/3">
                <img
                  src={logo1}
                  alt={cardData[activeCard].title}
                  className="w-full h-auto object-contain"
                />
              </div>
              <div className="flex flex-col gap-2 justify-center w-full md:w-2/3 p-4 md:pl-8 md:pr-8 my-6 md:my-12 lg:w-[63%] lg:pl-24 lg:pr-16 lg:my-36 bg-white rounded-2xl shadow-2xl">
                <div className="text-xl sm:text-2xl md:text-4xl lg:text-5xl font-light text-[#2F80ED] leading-tight mb-4">
                  {cardData[activeCard].title}
                </div>
                <ul className="text-sm sm:text-base md:text-lg font-light text-[#333333] list-disc pl-5 space-y-2">
                  {cardData[activeCard].description.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        )}
      </section>
    </div>
  );
};

export default TagSolu;
